let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("73Igd")).then(() => parcelRequire('c6Xlh'));